module.exports = __webpack_public_path__ + "static/media/owl.05ed9fb1.svg";